import { useSelector } from 'react-redux';

import { selectSportsbookQuickDepositEnabled } from '~/components/brand/ducks/selectors';
import useQuickDeposit from '~/components/payment/hooks/use-quick-deposit';
import { QDType } from '~/components/payment/util/constants';

const useSportsbookQuickDeposit = (shouldRefreshOnInit: boolean) => {
	const isQuickDepositEnabled = useSelector(selectSportsbookQuickDepositEnabled);
	return useQuickDeposit({ isEnabled: isQuickDepositEnabled, shouldRefreshOnInit, type: QDType.sportsbook });
};

export default useSportsbookQuickDeposit;
